const prepareOptionUser = user => ({label: user.nom + ' ' + user.prenom, value: user.id, is_actif: user.is_actif})

/**
 * Store Cabinets
 */
export default {
    state: {
        users: [],
    },

    mutations: {
        /**
         * Initialise le state users
         */
        setUsers: function (state, users) {
            state.users = users
        }
    },

    actions: {
        initUsers: function (context) {
            return axios.get('/api/users?paginate=0&order=nom&direction=asc').then(response => {
                context.commit('setUsers', response.data.data)
            })
        }
    },

    getters: {
        /**
         * Liste d'options d'utilisateurs
         */
        optionsUsers: state => state.users.map(prepareOptionUser),

        /**
         * Retourne l'utilisateur à partir de son id
         */
        getUserFromId: state => id => state.users.find(user => user.id === parseInt(id)),

        /**
         * Liste d'options de rôles
         */
        optionsRoles: () => [{label: 'Administrateur', value: 1}, {label: 'Modérateur', value: 2}, {label: 'Opérateur', value: 3}, {label: 'Commercial', value: 4}],

        /**
         * Liste d'options de superviseurs
         */
        optionsSuperviseurs: state => state.users.filter(user => user.is_superviseur).map(prepareOptionUser),

        /**
         * Liste d'options de collaborateurs
         */
        optionsCollaborateurs: state => state.users.filter(user => user.is_collaborateur).map(prepareOptionUser),

        /**
         * Liste d'options d'administratifs et adminTT
         */
        optionsAdministratifs: state => state.users.filter(user => user.is_administratif).map(prepareOptionUser),

        /**
         * Liste d'options user au role Commercial (+ Editeur pour gerer les user qui ont se role mais sont dans la liste a afficher pour commercial )
         * + filtre sur le user Valority pour ensuite l'afficher en fin de liste
        */
        optionsCommerciaux: state => {
            const filteredUsers = state.users.filter(user =>
                (user.id === 2 || user.role.id === 4) && user.id !== 195
            ).map(prepareOptionUser)

            const valorityUser = state.users.find(user => user.id === 195)
            if (valorityUser) {
                filteredUsers.push(prepareOptionUser(valorityUser))
            }

            return filteredUsers
        }
    }
}
